@if (showFab()) {
  <button
    [ngStyle]="fabStyle()"
    [flxDragPadding]="dragPadding"
    [flxDrag]="DragType.MAGNETIC"
    (click)="showWindow()"
    (flxDragEnd)="onDragEnd($event)"
    (flxDragMove)="onDragMove($event)"
    class="fixed w-10 h-10 flex flex-row justify-center items-center content-center bg-neutral-800 rounded-full"
    data-testId="ai-fab-button"
  >
    <flx-icon name="stars-flowx-white" />
  </button>
}
